import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Heading } from '@purpurds/purpur/heading';
import { Icon } from '@purpurds/purpur/icon';
import { Paragraph } from '@purpurds/purpur/paragraph';
import { purpurColorGray600, purpurColorGreen600, purpurColorOrange600, purpurColorPurple600, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import { Paper } from 'components/layout';
import { Overlay } from 'components/overlay2';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
import { icons } from 'theme/icons';
import spacing from 'theme/spacing';
import { pxToRem } from 'theme/utils';
const modalVariants = {
    success: {
        icon: icons.checkCircleFilled,
        color: purpurColorGreen600,
    },
    error: {
        icon: icons.error,
        color: purpurColorRed600,
    },
    warning: {
        icon: icons.warning,
        color: purpurColorOrange600,
    },
    info: {
        icon: icons.info,
        color: purpurColorPurple600,
    },
};
const ModalContainer = styled.div `
  margin: 0 ${spacing.spacing12};
  max-width: ${pxToRem(488)};
  width: 100%;

  ${props => props.$styledWidth &&
    css `
      max-width: fit-content;
    `}
`;
const StyledParagraph = styled(Paragraph) `
  margin-top: ${spacing.spacing8};
`;
const ModalActions = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: ${spacing.spacing24};
`;
const ActionButtonWrapper = styled.div `
  margin-right: ${spacing.spacing8};
  margin-bottom: ${spacing.spacing8};

  &:last-child {
    margin-right: 0;
    margin-bottom: 0;
  }
`;
const StyledHeading = styled(Heading) `
  display: flex;
  align-items: center;
  gap: ${spacing.spacing8};
`;
const StyledIcon = styled(Icon) `
  color: ${({ $color }) => $color || purpurColorGray600};
`;
export const Modal = ({ isOpen, onClose, children, title, actionButtons, style, biggerModal, }) => {
    const modalRoot = document.getElementById('modal-root');
    const variant = style ? modalVariants[style] : null;
    useEffect(() => {
        document.addEventListener('keydown', watchEscKey);
        return () => {
            document.removeEventListener('keydown', watchEscKey);
        };
    });
    const handleClose = () => {
        if (onClose)
            onClose();
    };
    const watchEscKey = (e) => {
        if (isOpen && (e.key === 'Escape' || e.key === 'Esc')) {
            handleClose();
        }
    };
    if (!modalRoot || !isOpen)
        return null;
    return createPortal(_jsx(Overlay, { onClick: handleClose, showOverlay: true, children: _jsx(ModalContainer, { "$styledWidth": biggerModal, children: _jsxs(Paper, { padding: spacing.spacing32, children: [_jsxs(StyledHeading, { tag: "h1", variant: "title-100", children: [variant && (_jsx(StyledIcon, { svg: variant.icon, size: "sm", "$color": variant.color })), title] }), _jsx(StyledParagraph, { children: children }), actionButtons && (_jsx(ModalActions, { children: React.Children.map(actionButtons, button => (_jsx(ActionButtonWrapper, { children: button }))) }))] }) }) }), modalRoot);
};
